import { contractTypeLabels } from "./employmentPresentation";
import type { BootstrapResponse, EmploymentContractType, Worker } from "./types";

/**
 * 구분은 계약이 정한다. 고용계약이 있으면 그 계약의 종류(정규직·기간제·업무위탁)고, 없으면
 * 도급제다 — 이 공장의 대부분이 계약서 없이 개수로 받는 분들이라 "계약이 없다"가 곧 하나의
 * 구분이다. 시간으로 정산하는 분은 단기알바, 로봇은 로봇이다.
 */
export type WorkerCategory = "piece" | "part_time" | "robot" | EmploymentContractType;

export const workerCategoryLabels: Record<WorkerCategory, string> = {
  piece: "도급제", ...contractTypeLabels, part_time: "단기알바", robot: "로봇"
};

/** One rule for every screen: the roster chips, the dispatch records, anywhere a
 *  worker is labelled. Returns a lookup by worker id. */
export function workerCategoryOf(data: Pick<BootstrapResponse, "employmentContracts">) {
  const activeContract = new Map(
    data.employmentContracts.filter(contract => contract.active).map(contract => [contract.workerId, contract.contractType])
  );
  return (worker: Pick<Worker, "id" | "kind" | "settlementType">): WorkerCategory =>
    worker.kind === "robot" ? "robot"
      : worker.settlementType === "hourly" ? "part_time"
      : activeContract.get(worker.id) ?? "piece";
}
